export const DOM_RF_LINK = 'https://наш.дом.рф';
